import {SetUserEmail} from "../general/SetUserEmail";

export const SetEmailPage = ({session, onComplete, props}) => {
    return <SetUserEmail session={session} onComplete={onComplete} />
}